import { render } from "./LegsTable.vue?vue&type=template&id=9bee9a3c"
import script from "./LegsTable.vue?vue&type=script&lang=js"
export * from "./LegsTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__